import ScormAPI2004 from '@/lib/ScormApi/ScormAPI2004'
import JsonFormatter from '@/lib/ScormApi/JsonFormatter'
import CommentsFromLearnerObjectInterface from "@/lib/ScormApi/Scorm2004/interfaces/CommentsFromLearnerObjectInterface"

export default function CommentsFromLearnerObject (api: ScormAPI2004): CommentsFromLearnerObjectInterface {
  let _comment = ''
  let _location = ''
  let _timestamp = ''
  return {
    get comment () {
      return _comment
    },
    set comment (comment) {
      _comment = comment
    },
    get location () {
      return _location
    },
    set location (location) {
      _location = location
    },
    get timestamp () {
      return _timestamp
    },
    set timestamp (timestamp) {
      _timestamp = timestamp
    },
    toJSON: new JsonFormatter().apply()
  }
}
